module.exports = __webpack_public_path__ + "img/1870_Eroeffnung-Vereinsbuchdruckerei.82dbdd47.jpg";